<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
export default {
  name: 'InstillingerMain'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/Instillinger.vue